import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { SvgIllustration, SvgModule } from '@ui/svg';
import { TextInputComponent } from '@ui/form/text-input/text-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { UiFormModule } from '@ui/form';
import { StatusBadgeStatus } from '@ui-v2/atoms/status-badge/status-badge.constants';
import { WaterDetailFormElementComponent } from '@app/services/water-transfer-document/components/water-detail-form-element/water-detail-form-element.component';

@Component({
    selector: 'app-water-meter-form',
    standalone: true,
    imports: [FormsModule, SvgModule, TextInputComponent, TranslateModule, UiFormModule, WaterDetailFormElementComponent],
    template: `
        <div [formGroup]="parentForm">
            <app-water-detail-form-element
                [showServiceStatusIcon]="showServiceStatusIcon"
                [serviceStatusIcon]="serviceStatusIcon"
                [title]="'V2.SERVICES.WATER.METER.TITLE'"
            >
                <smvd-ui-text-input
                    class="flex-grow"
                    formControlName="meterNumber"
                    [placeholder]="'V2.SERVICES.WATER.METER.METER_NUMBER.PLACEHOLDER' | translate"
                    [label]="'V2.SERVICES.WATER.METER.METER_NUMBER.LEGEND' | translate"
                ></smvd-ui-text-input>
                <app-meter-reading-input
                    class="flex-grow u-w100p"
                    formControlName="meterReading"
                    [placeholder]="'V2.SERVICES.WATER.METER.METER_READING.PLACEHOLDER' | translate"
                    ngDefaultControl
                    [label]="'V2.SERVICES.WATER.METER.METER_READING.LEGEND' | translate"
                    [hasMargin]="false"
                    [hasMarginDouble]="false"
                >
                </app-meter-reading-input>
            </app-water-detail-form-element>
        </div>
    `,
})
export class WaterMeterFormComponent {
    @Input() public parentForm: FormGroup;
    @Input() public showServiceStatusIcon: boolean = false;
    @Input() public serviceStatusIcon: StatusBadgeStatus;
    protected readonly svgIllustration = SvgIllustration;
}
